import React from 'react'
import {Icon} from '@chakra-ui/react'

const FavouriteFilledIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props}>
            <path
                d="M19.9103 36.5799C19.7476 36.5799 19.595 36.5393 19.4424 36.468C9.97174 31.5954 2.46438 23.0199 1.19281 15.6041C0.572282 12.0233 1.4573 8.8495 3.73595 6.42843C5.86202 4.18029 8.30344 3.02062 10.989 3.00027C11.0195 3.00027 11.0399 3.00027 11.0704 3.00027C15.0784 3.00027 18.4862 5.5129 19.9205 6.75395C21.3955 5.50273 24.9458 2.96976 29.0453 3.00027C31.741 3.04096 34.1825 4.19046 36.2882 6.42843C38.5465 8.81899 39.4213 11.9623 38.811 15.5024C37.5394 22.9182 29.9608 31.5445 20.3783 36.468C20.2359 36.5393 20.0731 36.5799 19.9103 36.5799Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default FavouriteFilledIcon
